"use strict";

var _typeof = require("/app/node_modules/@babel/runtime/helpers/typeof.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.crypto = void 0;
exports.crypto = {
  node: undefined,
  web: (typeof self === "undefined" ? "undefined" : _typeof(self)) === 'object' && 'crypto' in self ? self.crypto : undefined
};